import { render, staticRenderFns } from "./ExhibitorUpdate.vue?vue&type=template&id=16321e3a"
import script from "./ExhibitorUpdate.vue?vue&type=script&lang=ts"
export * from "./ExhibitorUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports